import { boxPropsType } from "../Box";
import { modalContentPropsType, } from "./components/ModalContent/types";
import { modalFooterPropsType, } from "./components/ModalFooter/types";
export const modalPropsType = boxPropsType.complete({
    closeOnClickOut: true,
    closeOnEsc: true,
    name: true,
    _size: true,
    visibility: true,
});
export const defaultModalProps = modalPropsType
    .extend(modalContentPropsType)
    .extend(modalFooterPropsType)
    .complete({
    postContent: true,
    preContent: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Nb2RhbC90eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQVksWUFBWSxFQUFFLE1BQU0sUUFBUSxDQUFDO0FBQ2hELE9BQU8sRUFFTCxxQkFBcUIsR0FDdEIsTUFBTSxpQ0FBaUMsQ0FBQztBQUN6QyxPQUFPLEVBRUwsb0JBQW9CLEdBQ3JCLE1BQU0sZ0NBQWdDLENBQUM7QUEwQ3hDLE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBRyxZQUFZLENBQUMsUUFBUSxDQUFhO0lBQzlELGVBQWUsRUFBRSxJQUFJO0lBQ3JCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLElBQUksRUFBRSxJQUFJO0lBQ1YsS0FBSyxFQUFFLElBQUk7SUFDWCxVQUFVLEVBQUUsSUFBSTtDQUNqQixDQUFDLENBQUM7QUFZSCxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxjQUFjO0tBQzVDLE1BQU0sQ0FBQyxxQkFBcUIsQ0FBQztLQUM3QixNQUFNLENBQUMsb0JBQW9CLENBQUM7S0FDNUIsUUFBUSxDQUFvQjtJQUMzQixXQUFXLEVBQUUsSUFBSTtJQUNqQixVQUFVLEVBQUUsSUFBSTtDQUNqQixDQUFDLENBQUMifQ==